var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOrderDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9 5.137c0-.55-.45-1-1-1h-1l-.003-1.193h-.006A1.997 1.997 0 0 0 14.897 1a1.997 1.997 0 0 0-1.994 1.944h-.006l.003 1.193h-1c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1zm3.997-.997h-2v1.897h2v18h-16v-18h2V4.14h-2C5.849 4.14 5 4.99 5 6.037v18c0 1.048.849 1.898 1.897 1.898h16c1.048 0 1.897-.85 1.897-1.898v-18a1.897 1.897 0 0 0-1.897-1.897zm-12.394 7.865h8.995a.504.504 0 0 0 0-1.005h-8.995a.505.505 0 0 0-.503.503c0 .276.227.502.503.502zm8.995 8.005h-8.995a.505.505 0 0 1-.503-.503c0-.276.227-.502.503-.502h8.995a.504.504 0 0 1 0 1.005zm-8.995-4.003h4.995a.504.504 0 0 0 0-1.005h-4.995a.505.505 0 0 0-.503.503c0 .276.227.502.503.502z",
    fill: "url(#h3whj5nwta)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h3whj5nwta",
    x1: 5,
    y1: 1,
    x2: 5,
    y2: 25.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AACE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrderDark);
export default __webpack_public_path__ + "static/media/ic-order-dark.e38905f6cb599f2c0a9384fa2a2c935e.svg";
export { ForwardRef as ReactComponent };